import { BreakpointsMap, constants } from "@findemdev/maui";
import styled from "styled-components";

const { colors, dimensions } = constants;

const DELIVERABLE_GRID_COLUMN = "4 / 10";
const DELIVERABLE_GRID_COLUMN_COMPACT = "1 / -1";
const DELIVERABLE_SCROLLBAR_SIZE = dimensions["border-radius"].sm;
const DELIVERABLE_ROW_GAP = "12px";
export const RAAS_DELIVERABLE_CONTENT_MAX_WIDTH = "700px";

export const DeliverableGridFrame = styled.div`
  --raas-deliverable-content-column: var(
    --raas-deliverable-content-column-override,
    ${DELIVERABLE_GRID_COLUMN}
  );
  --raas-deliverable-content-max-width: var(
    --raas-deliverable-content-max-width-override,
    ${RAAS_DELIVERABLE_CONTENT_MAX_WIDTH}
  );

  box-sizing: border-box;
  display: grid;
  flex: 1;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  height: 100%;
  min-height: 0;
  min-width: 0;
  padding: 0 ${dimensions.spacing["2"]};
  width: 100%;

  @media (max-width: ${BreakpointsMap.md}px) {
    --raas-deliverable-content-column: ${DELIVERABLE_GRID_COLUMN_COMPACT};
  }
`;

export const DeliverableGridContent = styled.div`
  grid-column: var(--raas-deliverable-content-column);
  justify-self: center;
  max-width: var(--raas-deliverable-content-max-width);
  min-width: 0;
  width: 100%;
`;

export const DeliverableReviewFrame = styled(DeliverableGridFrame)`
  grid-template-rows: minmax(0, 1fr) auto;
`;

export const DeliverableReviewContent = styled(DeliverableGridContent)`
  display: flex;
  flex-direction: column;
  gap: ${DELIVERABLE_ROW_GAP};
  grid-row: 1;
  justify-self: stretch;
  max-width: none;
  min-height: 0;
  overflow-y: auto;
  padding: ${dimensions.spacing["3"]} 0 ${dimensions.spacing["2"]};

  scrollbar-width: thin;
  scrollbar-color: ${colors["grey-400"]} transparent;

  &::-webkit-scrollbar {
    width: ${DELIVERABLE_SCROLLBAR_SIZE};
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors["grey-400"]};
    border-radius: ${dimensions["border-radius"].xs};
  }

  > * {
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    max-width: var(--raas-deliverable-content-max-width);
    width: 100%;
  }
`;
